import React from "react";
import { RequestComment } from "../../../../types/brm/request-types";
import { FormattedMessage, useIntl } from "react-intl";
import { isValid } from "date-fns";
import { Box, Typography } from "@mui/material";
import { TextInput } from "../../../common/form-controls";
import { Button } from "../../../common/buttons";

const RequestCommentComponent: React.FC<{ comment: RequestComment }> = ({ comment }) => {
    const intl = useIntl();
    const date = new Date(comment.createdAt);

    const dateString =
        isValid(date) &&
        intl.formatDate(date, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });

    return (
        <Box gap={1} display={"flex"} flexDirection={"column"}>
            <Typography sx={{ fontSize: "18px", fontWeight: "500", fontFamily: "Mulish" }}>{comment.authorText}</Typography>
            <Typography sx={{ fontFamily: "Mulish", fontWeight: "300", fontSize: "18px" }}>{comment.comment}</Typography>
            <Typography sx={{ fontFamily: "Mulish", fontWeight: "300", fontSize: "18px", color: "#828282" }}>{dateString}</Typography>
        </Box>
    );
};

type RequestDetailedCommentsTabProps = {
    newRequestComment: string;
    setNewRequestComment: (value: string) => void;
    comments: RequestComment[];
    onSaveCommentClick: () => void;
    disabled:boolean;
};

const RequestDetailedCommentsTab: React.FC<RequestDetailedCommentsTabProps> = ({ onSaveCommentClick, newRequestComment, setNewRequestComment, comments, disabled }) => {
    const intl = useIntl();

    return (
        <Box gap={3} display={"flex"} flexDirection={"column"} sx={{ width: "45%" }}>
            <Box gap={3} display={"flex"} flexDirection={"column"} sx={{ border: "1px solid #ACACAC", borderRadius: "4px", padding: "10px", height: "300px", overflowY: "auto" }}>
                {comments.length > 0 ? comments.map((comment, index) => <RequestCommentComponent key={index} comment={comment} />) : null}
            </Box>
            <Box>
                <TextInput
                    label={intl.formatMessage({ id: "request-detailed-comments-tab.input-send-new-comment.label" })}
                    value={newRequestComment}
                    onChange={(event) => setNewRequestComment(event.target.value)}
                    multiline={true}
                    rows={4}
                    disabled={disabled}
                />
                <Button
                    variant="outlined"
                    onClick={onSaveCommentClick}
                    disabled={!(newRequestComment?.length > 0) || disabled}
                    sx={{
                        color: "var(--font-4)",
                        borderColor: "var(--font-4)",
                        marginTop: "12px",
                    }}
                >
                    <FormattedMessage id="request-detailed-comments-tab.btn-send-new-comment" />
                </Button>
            </Box>
        </Box>
    );
};

export default RequestDetailedCommentsTab;
